import React from 'react'

const defaultState = {
  dark: false,
  rut: '',
  rutdata: {},
  infoacumulada2: [],
}

const SiteContext = React.createContext(defaultState)

class SiteProvider extends React.Component {
  state = {
    dark: false,
    rut: '',
    rutdata: {},
    infoacumulada2: [],
  }
  toggleDark = isDark => {
    if (isDark !== this.state.dark) {
      this.setState({ dark: isDark })
    }
  }

  saveRut = rut => {
    if (rut !== this.state.rut) {
      localStorage.setItem('rut', JSON.stringify(rut))
      this.setState({ rut: rut })
    }
  }

  addToInfo = data => {
    const dataWithRut = {
      ...data,
      rut: this.state.rut,
    }

    const updatedRutData = [...this.state.infoacumulada2, dataWithRut]

    localStorage.setItem('infoacumulada2', JSON.stringify(updatedRutData))
    this.setState({
      infoacumulada2: updatedRutData,
    })
    this.setState({
      rutdata: dataWithRut,
    })
  }

  setRutData = data => {
    const dataWithRut = {
      ...data,
      rut: this.state.rut,
    }
    this.setState({
      rutdata: dataWithRut,
    })
  }

  clearData = () => {
    this.setState({
      rut: defaultState.rut,
    })
    this.setState({
      rutdata: defaultState.rutdata,
    })
  }

  componentDidMount() {
    const lsrut = JSON.parse(localStorage.getItem('rut'))
    const lsMesaDatas = JSON.parse(localStorage.getItem('infoacumulada2'))

    if (lsMesaDatas) {
      this.setState({ infoacumulada2: lsMesaDatas })
    }
  }

  render() {
    const { children } = this.props
    const { dark, rut, infoacumulada2, rutdata } = this.state
    return (
      <SiteContext.Provider
        value={{
          dark,
          rut,
          infoacumulada2,
          rutdata,
          toggleDark: this.toggleDark,
          saveRut: this.saveRut,
          addToInfo: this.addToInfo,
          setRutData: this.setRutData,
          clearData: this.clearData,
        }}>
        {children}
      </SiteContext.Provider>
    )
  }
}

export default SiteContext
export { SiteProvider }
